import { NodeModel } from "../_model/NodeModel";
import { DecorationProductionChange } from "./decorationProductionChange"
import { Types } from "../../utils/nodeTypes"
import Properties from "../_model/ModelEngineeringProperties";
import { Input } from "../input/modelInput";
import { InputSeletora } from "../_service/simulationManagement/fixedCurrents"
import VisibleControl from "../../utils/visibleControl";

class ProductionChange extends NodeModel {
  constructor() {
    super("ProductionChange");
    
    this.type = new Types().ProductionChange;
    this.x = 0;
    this.y = 0;
    this.height = 20;
    this.width = 122;
    this.widthOption = 60;
    this.nodesToDest = []
    this.nodesToFab = []
    this.data = [ InputSeletora() ]

    this.fontSize = "11px"
    this.xTextDescription = () => this.x + 5;
    this.yTextDescription = () => this.y + 13;

    // Sugar
    this.xBoxSugar = () => this.x;
    this.yBoxSugar = () => this.y + 21.5;
    this.xTextSugar = () => this.xBoxSugar() + 5;
    this.yTextSugar = () => this.yBoxSugar() + 13;

    // Ethanol
    this.xBoxEthanol = () => this.x + 61.5;
    this.yBoxEthanol = () => this.y + 21.5;
    this.xTextEthanol = () => this.xBoxEthanol() + 5;
    this.yTextEthanol = () => this.yBoxEthanol() + 13;

    this.optionSelect = function (value) {
      if (!this.data[0]) return '0'
      if(value) this.data[0].value = value
      VisibleControl.setByPropertie(this.data[0])
      return this.data[0].value
    }
    
    this.decorate = async function(callback) {
      this.decorator = new DecorationProductionChange();
      await this.decorator.init(this,callback)
    };

    this.clone = () => {
      let cloned = new ProductionChange();
      cloned.type = this.type
      cloned.x = this.x
      cloned.y = this.y
      cloned.height = this.height
      cloned.width = this.width
      cloned.readOnly = this.readOnly;
      cloned.expressionVisible = this.expressionVisible
      cloned.optionSelect(this.optionSelect())
      cloned.nodesToDest = this.nodesToDest.map(d => d.clone())
      cloned.nodesToFab = this.nodesToFab.map(d => d.clone())
      cloned.data = this.data.map(d => d.clone())

      return cloned
    }

    this.copyFrom = (node) => {
      this.simpleCopyFrom(node);
      this.data = node.data.map(d => new Properties({...d, id: '' }))
      this.nodesToDest = node.nodesToDest.map(d => {
        let input = new Input()
        input.copyFrom(d) 
        return input
      })
      this.nodesToFab = node.nodesToFab.map(d => {
        let input = new Input()
        input.copyFrom(d) 
        return input
      })
    }
  }
}

export { ProductionChange };
